import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

import { shipping } from './modules/shipping'
import { shoppingCartText } from './modules/shopping_cart_text'
import products from './modules/products'
import variants from './modules/variants'
import categories from './modules/categories'
import currencies from './modules/currencies'
import payments from './modules/payments'
import accounts from './modules/accounts'
import ccEmails from './modules/cc_emails'
import orderCustomForm from './modules/order_custom_form'
import contactForm from './modules/contact_forms'
import properties from './modules/properties'
import sortOptions from './modules/sort_options'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentProduct: {
      id: 0,
      defaultImages: [
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''}
      ],
      images: [
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''}
      ],
      variantSetting: {
        page: 1,
        limit: 5,
        sort: 'id',
        order: 'asc'
      },
      variantImageEdit: {
        id: 0,
        index: 0,
        image_path: ''
      },
      imagesLimit: 9,
      imagesCount: 0,
      relatedProducts: []
    },
    currentCategory: {
      id: 0,
      name: 'Main Category',
      childs: [],
      parents: []
    },
    productVariants: {},
    currentProductVariants: {
      id: 0,
      images: [
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''},
        {image_path: ''}
      ],
      imagesLimit: 9,
      imagesCount: 0
    },
    categories: [],
    attributes: [],
    attributeStateSelect: {},
    orders: {
      result: {
        list: [],
        page_total: 0,
        order_total: 0,
        current_page: 0
      },
      search: {
        keyword: '',
        date1: null,
        date2: null,
        searchStatus: false,
        createDate: false,
        page: 1,
        limit: 20,
        update_date_1: null,
        update_date_2: null,
        updateDate: false,
        dateType: 'between',
        updateDateType: 'between',
        orderType: false,
        orderTypeChoice: 'cart',
        orderStatus: false,
        orderStatusChoice: 'new',
        sort: 'create_date',
        order: 'desc',
        countSearchFilter: 0,
        isSearch: false
      },
      advanceSearch: false,
      searchInputClear: false,
      addressToggle: false,
      grandTotal: 0
    },
    input: {
      orderFrom: 'www.test1.com',
      shippingAddress: {
        firstname: '',
        lastname: '',
        email: '',
        tel: '',
        address: '',
        address2: '',
        country: '1',
        province: '',
        district: '',
        subDistrict: '',
        postcode: ''
      },
      contactAddress: {
        firstname: '',
        lastname: '',
        email: '',
        tel: '',
        address: '',
        address2: '',
        country: '1',
        province: '',
        district: '',
        subDistrict: '',
        postcode: ''
      },
      orderId: '0'
    },
    rmp_business: {
      business_id: ''
    },
    productList: [],
    addNewProductList: [],
    newProductRemoveList: []
  },
  mutations,
  actions,
  getters,
  modules: {
    products,
    categories,
    currencies,
    shipping,
    variants,
    shoppingCartText,
    payments,
    accounts,
    ccEmails,
    orderCustomForm,
    contactForm,
    properties,
    sortOptions
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js